module.exports = __webpack_public_path__ + "static/media/tick.91b58e9e.svg";